import React from 'react';
import propTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PROP_TYPE_ERROR =
  'You need to provide at least one of `to`, `onClickButton` or `renderButton` props';

export function UiEmptyState({
  title,
  to,
  onClickButton,
  renderButton,
  hideButton,
}) {
  const Button = to ? NavLink : 'button';

  return (
    <div className="ui-empty-state has-text-centered">
      {!hideButton && (
        <p className="subtitle has-text-grey is-6 is-spaced">
          Ready to Get Started?
        </p>
      )}
      <p className="title has-text-primary is-4">
        {!hideButton ? `Upload Your First ${title}!` : 'No items available.'}
      </p>
      {!hideButton &&
        (renderButton || (
          <Button
            className="button is-gradient-bright is-long is-large"
            to={to}
            onClick={onClickButton}
          >
            <span className="icon is-left">
              <FontAwesomeIcon icon={['fal', 'plus']} />
            </span>
            <span>{title}</span>
          </Button>
        ))}
    </div>
  );
}

UiEmptyState.defaultProps = {
  to: '',
  onClickButton: null,
  renderButton: null,
  hideButton: false,
};

UiEmptyState.propTypes = {
  title: propTypes.string.isRequired,
  // eslint-disable-next-line consistent-return
  to(props, propName) {
    if (
      !props.hideButton &&
      !props.onClickButton &&
      !props[propName] &&
      !props.renderButton
    ) {
      return new Error(PROP_TYPE_ERROR);
    }
  },
  // eslint-disable-next-line consistent-return
  onClickButton(props, propName) {
    if (
      !props.hideButton &&
      !props.to &&
      !props[propName] &&
      !props.renderButton
    ) {
      return new Error(PROP_TYPE_ERROR);
    }
  },
  renderButton: propTypes.node,
  hideButton: propTypes.bool,
};
